// The GTM script on the WWW site sets a `.layer.ai` cookie `referrer_url` on
// first touch, before any redirects, so it preserves the true origin referrer.
// Fall back to `document.referrer` when the cookie is absent.
const REFERRER_COOKIE_NAME = "referrer_url";

const readReferrerCookie = (): string => {
  if (typeof document === "undefined") return "";
  const match = document.cookie
    .split(";")
    .find((row) => row.trim().startsWith(`${REFERRER_COOKIE_NAME}=`));
  if (!match) return "";
  try {
    return decodeURIComponent(match.slice(REFERRER_COOKIE_NAME.length + 1));
  } catch {
    return "";
  }
};

export const getReferrerUrl = (): string => {
  const fromCookie = readReferrerCookie();
  if (fromCookie) return fromCookie;
  return typeof document !== "undefined" ? document.referrer : "";
};
